import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IProductTypeModel } from '@apps-common/types/management/product'

export const getProductTypes = async (): Promise<IProductTypeModel[]> =>
  axios.get(`/management/product/getproducttypes`).then((res) => res.data?.data)

type QueryFnType = typeof getProductTypes

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useManagementGetProductTypes = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getProductTypes'],
    queryFn: () => getProductTypes()
  })
